import { render, staticRenderFns } from "./FaqItemPage.vue?vue&type=template&id=fbd0c01e"
import script from "./FaqItemPage.vue?vue&type=script&lang=js"
export * from "./FaqItemPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports